import { Component, Input, ViewChild, inject } from '@angular/core';
import { Accordion } from 'primeng/accordion';
import { AuthorizationService } from 'src/app/auth/services/authorization.service';
import { SessionService } from 'src/app/auth/services/session.service';
@Component({
    selector: 'app-larm-details',
    templateUrl: './larm-details.component.html',
    styleUrls: ['./larm-details.component.scss'],
    standalone: false
})
export class LarmDetailsComponent {
  @Input() row!: any;
  @Input() showBy?: string;
  @ViewChild('accordion') accordion!: Accordion;

  protected sessionService = inject(SessionService);
  protected authorizationService = inject(AuthorizationService);

  protected goToProv(provLabbProvtagningsar: string) {
    var popup = window.open(`/inskicksresultat`, '_blank');
    (popup as any).provLabbProvtagningsar = provLabbProvtagningsar;
  }

  protected goToLarmKriterium(kriteriumName: string) {
    (this.showBy === 'Larmkriterie' && this.sessionService.isInternUser)
      ? window.open(`/larm-kriterium?kriteria=${this.row.accordionHeader}`, '_blank')
      : window.open(`/larm-kriterium?kriteria=${kriteriumName}`, '_blank');
  }

  protected expanded(index: number) {
    //return this.accordion?.tabs[index].selected;
    return this.accordion?.value() === index;
  }
}
